import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AdvanceService } from 'src/app/shared/services/advance.service';
import { Advance, AdvanceTypes } from 'src/app/shared/models/advance.model';
import { TableDataSource } from 'src/app/shared/components/table/table-data-source';
import { MatSort, Sort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { tableSortFn, compareSortFn } from 'src/app/shared/utils/sort.util';
import { Employee } from 'src/app/shared/models/employee.model';
import { EmployeeService } from 'src/app/shared/services/employee.service';

@Component({
  selector: 'app-advances-employees-archives',
  templateUrl: './advances-employees-archives.component.html'
})
export class AdvancesEmployeesArchivesComponent implements OnInit, AfterViewInit {
  advances: Advance[];
  employees$;
  advances$;
  dataSource = new TableDataSource<Advance>();

  @ViewChild(MatSort, { static: false }) set sort(sort: MatSort) {
    this.dataSource.sort = sort;

    if(this.dataSource.sort) {
      this.dataSource.sort.sortChange.subscribe((sortState: Sort) => {
        this.onSortChange(sortState)
      })
    }
  }

  constructor(
    private advanceService: AdvanceService,
    private employeeService: EmployeeService,
  ) { }

  ngOnInit() {
    this.advances$ = this.advanceService.fetchInactiveAdvances().pipe(
      map((advances: Advance[]) => {
        this.advances = this.dataSource.data = advances;
        this.dataSource.sortingDataAccessor = tableSortFn;
        return advances;
      }),
    );

    this.employees$ = this.employeeService.activeEmployees$;
  }

  ngAfterViewInit() {
    if(this.sort) {
      this.dataSource.sort = this.sort;
      const initialSortState: Sort = { active: 'employee', direction: 'asc' };

      // Set the initial sort state
      this.sort.active = initialSortState.active;
      this.sort.direction = initialSortState.direction;
  
      // Manually trigger the sort change event
      this.sort.sortChange.emit(initialSortState);
      this.onSortChange(initialSortState);
    }

  }

  onSelectEmployee(employee: Employee) {
    console.log(employee, this.dataSource.data)
    if (employee) {
      this.dataSource.data = this.advances.filter((delegation: any) => delegation.employee.id === employee.id);
      return;
    }
    this.dataSource.data = this.advances;
  }

  onSortChange(sortState: Sort) {
    const data = this.advances.slice();
    if (!sortState.active || sortState.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sortState.direction === 'asc';
      switch (sortState.active) {
        case 'employee':
          return compareSortFn((a.employee as Employee).person.lastName, (b.employee as Employee).person.lastName, isAsc);
        case 'id':
          return compareSortFn(a.id, b.id, isAsc);
        default:
          return 0;
      }
    });
  }

}
